import { TRY } from "@/lib/format";
import { BookOpen, FileWarning, ArrowLeftRight, Scale, AlertTriangle } from "lucide-react";

const r2 = (v) => Math.round(Number(v || 0) * 100) / 100;
const stateText = (v) => (v > 0.005 ? "Müşteri bize borçlu (alacağımız)" : v < -0.005 ? "Biz cariye borçluyuz" : "Hesap kapalı");

function Part({ icon: Icon, label, value, sub, title, testid }) {
  return (
    <div className="flex-1 min-w-0 px-4 py-3" title={title}>
      <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-500"><Icon className="h-3.5 w-3.5 text-[#0F2745]" />{label}</div>
      <div className="font-head font-black text-lg tabular-nums text-[#0F2745] mt-0.5" data-testid={testid}>{TRY(value)}</div>
      <div className="text-[11px] text-muted-foreground leading-snug line-clamp-2">{sub}</div>
    </div>
  );
}
const Op = ({ children }) => <div className="hidden md:flex items-center text-slate-300 font-head font-black text-xl px-1 select-none" aria-hidden>{children}</div>;

// Cari açılınca üstte kısa uyarı: ödenmemiş satış faturası varsa (ayrıntı Cari Defter → Hesap Özeti'nde)
export function UnpaidInvoicesAlert({ list }) {
  if (!list.length) return null;
  const sum = r2(list.reduce((s, u) => s + u.remaining, 0));
  return (
    <div className="shrink-0 rounded-lg border border-red-200 bg-red-50 px-3 py-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-xs text-red-900" data-testid="unpaid-alert">
      <AlertTriangle className="h-4 w-4 text-red-600 shrink-0" />
      <b data-testid="unpaid-alert-summary">{list.length} ödenmemiş fatura · Kalan {TRY(sum)}</b>
      <span className="min-w-0 text-red-800/90">{list.map((u) => `${u.no} (${TRY(u.remaining)})`).join(" · ")}</span>
      <span className="sm:ml-auto text-red-700/80">Ayrıntı: Cari Defter → Hesap Özeti</span>
    </div>
  );
}

// Sayfanın en altında tek, sade Genel Bakiye özeti: Defter bakiyesi + Ödenmemiş faturalar (+ Diğer) = Genel bakiye
export function ContactBalanceBar({ ledgerOpen, unpaid, overall, isFolder }) {
  const unpaidSum = r2(unpaid.reduce((s, u) => s + u.remaining, 0));
  const other = r2(overall - ledgerOpen - unpaidSum);
  return (
    <section className="rounded-xl border bg-card shadow-sm overflow-hidden" data-testid="balance-bar">
      <div className="flex flex-col md:flex-row md:items-stretch divide-y md:divide-y-0">
        {!isFolder && (
          <>
            <Part icon={BookOpen} label="Cari Defter Bakiyesi" value={ledgerOpen} sub="Defterdeki ürünler − defter ödemeleri" testid="balance-ledger" />
            <Op>+</Op>
            <Part icon={FileWarning} label="Ödenmemiş Faturalar" value={unpaidSum}
              sub={unpaid.length ? `${unpaid.length} fatura · ${unpaid.map((u) => u.no).join(", ")}` : "Açık fatura yok"}
              title={unpaid.map((u) => `${u.no}: ${TRY(u.remaining)}`).join("\n")} testid="balance-invoices" />
            {Math.abs(other) >= 0.01 && (
              <>
                <Op>+</Op>
                <Part icon={ArrowLeftRight} label="Diğer Hareketler" value={other} sub="Alış faturaları, tedarikçiye ödemeler, avans vb." testid="balance-other" />
              </>
            )}
            <Op>=</Op>
          </>
        )}
        <div className="relative md:min-w-[280px] bg-[#0F2745] text-white px-5 py-3">
          <span className="absolute left-0 top-3 bottom-3 w-1 rounded-r bg-[#F2B705]" />
          <div className="flex items-center gap-1.5 text-[10px] font-bold uppercase tracking-[0.14em] text-slate-300"><Scale className="h-3.5 w-3.5 text-[#F2B705]" />Genel Bakiye{isFolder ? " (alt cariler dahil)" : ""}</div>
          <div className="font-head font-black text-2xl tabular-nums text-[#F2B705]" data-testid="balance-overall">{TRY(overall)}</div>
          <div className="text-[11px] text-slate-300" data-testid="balance-state">{stateText(overall)}</div>
        </div>
      </div>
    </section>
  );
}
